import { baseApi } from '@/utils/requestConfig'

export function getUserAccountInfo(cknr) {
  return baseApi.get('/my-profile/account', { headers: { 'oeamtc-identity-cknr': cknr } })
}

export function updateUserPhone(payload) {
  return baseApi.put('/my-profile/account', payload)
}

export function updateUserEmail(payload) {
  return baseApi.post('/my-profile/email/changes', payload)
}
